import Breadcrumbs from './Breadcrumbs';

export type { BreadcrumbsProps, Breadcrumb } from './Breadcrumbs';

export * from './Breadcrumbs.theme';

export default Breadcrumbs;
